import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'

import Select from 'components/common/Select'

const SortSelect = ({ value, onChange, color }) => {
  return (
    <Box display="flex" flexWrap="nowrap" alignItems="center">
      <Box mr={3}>
        <Typography color="textSecondary">排序</Typography>
      </Box>
      <div>
        <Box sx={{ minWidth: 110 }}>
          <FormControl fullWidth>
            <Select
              size="large"
              color={color || 'primary'}
              value={value}
              onChange={onChange}
            >
              <option value="-sort -createdTime">推薦排序</option>
              <option value="-photoTotalViews">熱門程度</option>
              <option value="-updateFieldsAtTime">由新到舊</option>
            </Select>
          </FormControl>
        </Box>
      </div>
    </Box>
  )
}

export default SortSelect
